const dataLayer = window.dataLayer || [];
const watchTheStoryEvent = {
  'event': 'GAevent',
  'eventCategory': 'page_crosslink_click',
  'eventAction': 'watch_the_story',
  'eventLabel': 'ForAGoodLife Youtube video'
};
const videoPopupEvent = {
  'event': 'GAevent',
  "eventCategory": "click_video_popup",
  "eventAction": "video_popup",
  "eventLabel": "Click on video popup"
};
const behindTheScenesEvent = {
    "event": "GAevent",
    "eventCategory": "page_crosslink_click",
    "eventAction": "step_behind_the_scenes",
    "eventLabel": "Click on Step Behind The Scenes"
}
const ctaSalonLocatorEvent = {
  'event': 'GAevent',
  "eventCategory": "cta_salon_locator",
  "eventAction": "cta_salon_locator",
  "eventLabel": "Click on salon locator"
}

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const target = e.target;
    /* 
      We do not have control over Gempages HTML structure.

      We check if the click happened on an element that could be a cta:
      - anchor tag
      - button tag
      - img containing one of the above tags
      - span elements (incoming CTA may include a span element wrapping the text)

      If we don't do so, we risk tracking events unintentionally, for example:
      - clicks on empty space around the actual <a> tag
      - clicks on empty space around button tag

      Then, we track the event if direct target or parent has the expected class.
    */
     if(target.matches('a, button, img, span')) {
      if (target.closest('.gem-watch-the-story')) {
        dataLayer.push(watchTheStoryEvent);
      } else if(target.closest('.gem-video-popup')) {
        dataLayer.push(videoPopupEvent);
      } else if(target.closest('.gem-behind-the-scenes')) {
        dataLayer.push(behindTheScenesEvent);
      } else if(target.closest('.gem-cta-salon-locator')) {
        dataLayer.push(ctaSalonLocatorEvent);
      }
    }
  });
});